import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1]; // ease-out dei token (03-tokens.css)

export const Rise = ({ children, delay = 0, className = "" }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-8% 0px -8% 0px" }}
            transition={{ duration: 1, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
};

export const Words = ({ text, italic = false, delay = 0, stagger = 0.08, className = "", inView = true }) => {
    const reduce = useReducedMotion();
    return (
        <motion.span
            className={`${italic ? "ital" : ""} ${className}`}
            initial={reduce ? false : "hidden"}
            {...(inView ? { whileInView: "show", viewport: { once: true, margin: "-8% 0px" } } : { animate: "show" })}
        >
            {text.split(" ").map((w, i) => (
                <span className="w-mask" key={`${w}-${i}`}>
                    <motion.span
                        className="w-word"
                        variants={{
                            hidden: { y: "112%" },
                            show: {
                                y: 0,
                                transition: {
                                    duration: 0.9,
                                    ease: EASE,
                                    delay: delay + i * stagger,
                                },
                            },
                        }}
                    >
                        {w}
                    </motion.span>
                </span>
            ))}
        </motion.span>
    );
};
